import { createElementObject, createLayerComponent, extendContext } from './core';
import L from '@anlan/gs-map';
import type { LatLngExpression, Marker as LeafletMarker, MarkerOptions } from '@anlan/gs-map';
import type { ReactNode } from 'react';
import type { EventedProps, LeafletContextInterface } from './core';

import icon from './images/marker-icon-2x.png';
import iconShadow from './images/marker-shadow.png';

// 解决leaflet默认图标不显示问题
const DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

export interface MarkerProps extends MarkerOptions, EventedProps {
    children?: ReactNode
    position: LatLngExpression
}

export const Marker = createLayerComponent(function createMarker({ position, ...options }: MarkerProps, ctx: LeafletContextInterface) {
    const marker = new L.Marker(position, options);
    return createElementObject(marker, extendContext(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker: LeafletMarker, props: MarkerProps, prevProps: MarkerProps) {
    if (props.position !== prevProps.position) {
        marker.setLatLng(props.position);
    }
    if (props.icon != null && props.icon !== prevProps.icon) {
        marker.setIcon(props.icon);
    }
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) {
        marker.setZIndexOffset(props.zIndexOffset);
    }
    if (props.opacity != null && props.opacity !== prevProps.opacity) {
        marker.setOpacity(props.opacity);
    }
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) {
            marker.dragging.enable();
        } else {
            marker.dragging.disable();
        }
    }
});
